export default {
  home: "Home",
  news: "News",
  product: "Product",
  upgrade: "Notification",
  about: "About",
  feedback: "Feedback",
  support: "Product Instruction",
  personal: "Personal",
  userCenter: "User Center",
  login: "Login",
  register: "Register",
  layout: "Layout",
  classify: "Classify",
  manualClassify: "Classify",
  videoClassify: "Classify",
  guide: "Guide",
  manual: "Manual",
  video: "Video",
  download: "Download",
  name: "Name",
  date: "Date",
  updateDate: "Date",
  info: "Info",
  type: "Type",
  sn: "SN",
  upgradeImmediately: "Upgrade immediately",
  resetPassword: "Reset Password",
  submit: "Submit",
  code: "Code",
  getCode: "get code",
  email: "Email",
  emailNew: "New Email",
  tel: "Tel",
  password: "Password",
  newPassword: "New Password",
  forgetPassword: "Forget Password",
  userName: "UserName",
  introduce: "Introduce",
  contactUs: "Contact Us",
  issueName: "Name",
  issueDate: "Date",
  videoName: "Name",
  tipsSn: "Please go to Personal Center to add device number",
  tipsSearch: "Search text must be entered",
  synopsis: "Synopsis",
  synopsisClassify: "Synopsis Classify",
  tipsLogin: "Need to log in to",
  professionalServices: "Professional Services",
  professionalServicesText:
    "Personnel in the professional field for more than ten years are responsible for handling difficult problems and faults.",
  strongTechnicalAbility: "Strong Technical Ability",
  strongTechnicalAbilityText:
    "Use a variety of technologies to give full play to team strength to help customers debug and solve faults.",
  focusOnCustomerServices: "Focus On Customer Services",
  focusOnCustomerServicesText:
    "Use corporate WeChat to provide online answers to help companies quickly and accurately solve problems and faults.",
  worryfreeMaintenanceOfIterativeWarranty:
    "Worry-free Maintenance Of Iterative Warranty",
  worryfreeMaintenanceOfIterativeWarrantyText:
    "Unified management of the project. Technical support engineer responsible for answering questions.",
  indextitle: "THE REASON TO CHOOSING US",
  emailRegister: "Email",
  mobileRegister: "Mobile",
  search: "Search",
  searchTips: "Please enter a search term",
  serviceTitle: "TROUBLE CODE MAINTENANCE INFORMATION QUERY",
  vehicleBrands: "Vehicle Brands",
  year: "Year",
  carModel: "Car Model",
  electricSystem: "Electric System",
  ecu: "ECU",
  searchContent: "Search Content",
  myProfile: "My Profile",
  myOrders: "My Orders",
  mySN: "My SN",
  edit: "Edit",
  phone: "Tel",
  account: "account",
  add: "Add",
  tipSn: "Please enter device serial number",
  dates: "Date",
  infos: "Info",
  price: "Price",
  deviceNumber: "Device Number",
  payStatus: "Pay Status",
  edits: "Edits",
  downloads: "Download",
  paymentMethod: "Please select payment method",
  amount: "Amount",
  changeTheTel: "Change The Tel",
  changeThePassword: "Change The Password",
  changeTheEmail: "Change The Email",
  oldPhone: "Old Phone",
  newPhone: "New Phone",
  oldEmail: "Old Email",
  moblieText: "Only use Chinese mobile phone number to register"
};
